export const LOCALES = ['en', 'nl'];
export const DEFAULT_LOCALE = 'en';

export const isLocale = (value) => LOCALES.includes(value);

export const getLocaleFromPathname = (pathname = '') => {
  const match = pathname.match(/^\/(en|nl)(?=\/|$)/);
  return match ? match[1] : DEFAULT_LOCALE;
};

export const stripLocale = (pathname = '') => {
  const stripped = pathname.replace(/^\/(en|nl)(?=\/|$)/, '');
  return stripped || '/';
};

export const locPath = (lang, to = '/') => {
  if (to == null) return `/${lang}`;
  if (typeof to !== 'string') return to;
  if (/^(https?:|mailto:|tel:)/i.test(to)) return to;
  if (to.startsWith('#')) return to;
  if (to.startsWith('/admin')) return to;

  const locale = isLocale(lang) ? lang : DEFAULT_LOCALE;
  const pathOnly = to.split(/[?#]/)[0];
  if (pathOnly === '/admin' || pathOnly.startsWith('/admin/')) return to;

  const already = to.match(/^\/(en|nl)(?=\/|$|\?|#)/);
  if (already) {
    return to.replace(/^\/(en|nl)/, `/${locale}`);
  }

  let path = to;
  let suffix = '';
  const queryAt = to.indexOf('?');
  const hashAt = to.indexOf('#');
  const cutCandidates = [queryAt, hashAt].filter((i) => i >= 0);
  const cut = cutCandidates.length ? Math.min(...cutCandidates) : -1;
  if (cut >= 0) {
    path = to.slice(0, cut);
    suffix = to.slice(cut);
  }

  if (path === '' || path === '/') return `/${locale}${suffix}`;
  if (!path.startsWith('/')) path = `/${path}`;
  return `/${locale}${path}${suffix}`;
};

export const switchLocalePath = (pathname, nextLang, search = '', hash = '') => {
  const rest = stripLocale(pathname);
  return `${locPath(nextLang, rest)}${search}${hash}`;
};
